import * as React from "react";

import { formatCurrency, formatDate } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import BackOfficeLink from "app/components/BOComponents/BackOfficeLink";

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: (row) => formatDate(row.created_at),
  },
  {
    name: "Wallet",
    render: (row) => (
      <BackOfficeLink
        backofficeUrl={`/snapscan/wallets/${row.wallet_name}/users`}
      >
        {row.wallet_name}
      </BackOfficeLink>
    ),
  },
  {
    name: "Payment",
    render: (row) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/payments/${row.payment.reference}/summary`}
        snapminUrl={row.payment.snapmin_url}
      >
        {row.payment.payment_strategy}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "From",
    render: (row) => {
      const friendFrom = row.friend_connection?.from;
      if (!friendFrom) return "Unknown";
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/users/${friendFrom.external_reference}/payments`}
          snapminUrl={friendFrom.snapmin_url}
        >
          {friendFrom.email}
        </BackOfficeAndSnapminLink>
      );
    },
  },
  {
    name: "To",
    render: (row) => {
      const friendTo = row.friend_connection?.to;
      if (!friendTo) return "Unknown";
      return (
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/users/${friendTo.external_reference}/payments`}
          snapminUrl={friendTo.snapmin_url}
        >
          {friendTo.email}
        </BackOfficeAndSnapminLink>
      );
    },
  },
  {
    name: "Amount",
    cellProps: { align: "right" },
    render: (row) => `R${formatCurrency(row.amount)}`,
  },
  {
    name: "Status",
    render: (row) => row.payment.status,
  },
  {
    name: "Reason",
    render: (row) => row.payment.user_reference,
  },
];

export default columnConfigs;
